const apiList = {
  // 帮助中心首页
  'apiList_API名称': {
    cn: 'API名称',
    en: 'Name of the API'
  },
  'apiList_收费类型': { cn: '收费类型', en: 'Charge type', kr: '' },
  'apiList_API列表': { cn: 'API列表', en: 'Api list' },
  'apiList_接口名称': { cn: '接口名称', en: 'Interface name' },
  'apiList_描述': { cn: '描述', en: 'describe' },
  'apiList_收费': { cn: '收费', en: 'Charge' },
  'apiList_免费': { cn: '免费', en: 'Free' },
  'apiList_系统': { cn: '系统', en: 'System', kr: '체계' }
}

export default {
  ...apiList
}
